// ABOUTME: Context and hook for the authenticated user (Me) and role management.
// ABOUTME: The provider lives in UserProvider.tsx; this file has no components so Fast Refresh keeps state.

import { createContext, useContext } from "react"
import type { Me } from "./me"
import { Role } from "@/graphql/main/gql/graphql"
import config from "@/config"

export interface MeContextType {
  me: Me
  loading: boolean
  currentRole: {
    isAthlete: boolean
    isCoach: boolean
    get: Role
    set(role: Role): void
  }
}

export const MeContext = createContext<MeContextType | undefined>(undefined)

export const useMeContext = (): MeContextType => {
  const context = useContext(MeContext)

  if (!context) {
    // During HMR, components may render before context is available
    // In development, return a stub to prevent crashes during hot reload
    if (config.IS_DEV && import.meta.hot) {
      // Return a stub context that will be replaced on next render
      return {
        me: { id: "", user: { email: "" } } as Me,
        loading: true,
        currentRole: {
          isAthlete: false,
          isCoach: false,
          get: Role.Athlete,
          set: () => {},
        },
      }
    }
    throw new Error("useUserContext must be used within a UserProvider")
  }

  return context
}
